export const createModuleI18nNamespaces = ({
  resource,
}: {
  resource: string;
}) => {
  return {
    list: () => `module-${resource}-list`,
    form: ({ type, tab }: { type: "edit" | "create"; tab?: string }) => {
      if (tab) {
        return `module-${resource}-${type}-${tab}`;
      }
      return `module-${resource}-${type}`;
    },
    layout: () => `module-${resource}-layout`,
  };
};
